import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { GraviButton, NothingMessage } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import { Divider, Drawer, notification, Popconfirm, Skeleton } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'

import { HistoryItem } from './HistoryItem'

export function RequestedChangesDrawer({ changeId, setChangeId, onClose, onOrderChange }) {
  const [requestedChanges, setRequestedChanges] = useState()
  const [loading, setLoading] = useState(false)
  const { scopes, user } = useSecurityContext()

  // Nathan said this is the only way to do it..
  const canAccept = scopes?.order_management?.carrier_approve_updates

  useEffect(() => {
    if (changeId) {
      setLoading(true)
      api
        .crossroadsOrderChangeSummary(changeId)
        .then((resp) => {
          const data = resp?.data
          setRequestedChanges(data)
        })
        .finally(() => setLoading(false))
    }
  }, [changeId])

  const handleAccept = useCallback(async () => {
    if (changeId) {
      setLoading(true)
      api
        .crossroadsOrderChangeAccept(changeId)
        .then((resp) => {
          notification.success({
            message: `Changes accepted`,
          })
          onOrderChange(resp?.data)
        })
        .finally(() => {
          setLoading(false)
          setChangeId(undefined)
        })
    }
  }, [changeId])

  const handleReject = useCallback(async () => {
    if (changeId) {
      setLoading(true)
      api
        .crossroadsOrderChangeReject(changeId)
        .then((resp) => {
          notification.info({
            message: `Changes rejected`,
          })
          onOrderChange(resp?.data)
        })
        .finally(() => {
          setLoading(false)
          setChangeId(undefined)
        })
    }
  }, [changeId])

  return (
    <>
      {changeId && requestedChanges && (
        <Drawer
          title={`Requested Changes for Order #${requestedChanges[0]?.extra_data?.number}`}
          placement='right'
          closable
          onClose={onClose}
          open={!!changeId}
          key='right'
          width='600'
          rootStyle={{
            height: '100%',
            overflowY: 'scroll',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Content requestedChanges={requestedChanges} loading={loading} />
            <div style={{ flexGrow: 1 }} />
            {canAccept && (
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
                <Popconfirm title='Are you sure you want to reject these changes?' onConfirm={handleReject}>
                  <GraviButton buttonText='Reject Changes' disabled={loading} />
                </Popconfirm>
                <Popconfirm title='Are you sure you want to accept these changes?' onConfirm={handleAccept}>
                  <GraviButton buttonText='Accept Changes' theme2 className='mr-2' disabled={loading} />
                </Popconfirm>
              </div>
            )}
          </div>
        </Drawer>
      )}
    </>
  )
}

function Content({ requestedChanges, loading }) {
  if (loading) {
    return <Skeleton active avatar paragraph={{ rows: 4 }} />
  }
  return (
    <>
      {requestedChanges ? (
        requestedChanges.map((change, index) => (
          <div key={change.id} style={{ marginBottom: '1rem' }}>
            <HistoryItem action={change} isRequestedChangeAudit />
            <Divider />
          </div>
        ))
      ) : (
        <NothingMessage
          className='audit-no-data'
          title='No Audit History Exists'
          message='Future changes can be viewed here'
        />
      )}
    </>
  )
}
